import { SVGProps } from "react";

const Important = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={5}
    viewBox="0 0 14 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 4L7 1L13 4"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Important;
